import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormArray, Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductDao } from '@app/dao/product/product.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { combineLatest } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-owners-profession-details',
    templateUrl: './credit-owners-profession-details.component.html',
    styleUrls: ['./credit-owners-profession-details.component.scss'],
    standalone: false
})
export class CreditOwnersProfessionDetailsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionsProfessionCategory: any[] = [];
  optionsProfessionCategorySub: any[] = [];
  optionsProfessionSocialRegime: any[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
    protected productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);

    combineLatest([
      this.productDao.getDigitalInsureProfessionnalCategoryRef(),
      this.productDao.getDigitalInsureProfessionnalSubCategoryRef(),
      this.productDao.getDigitalInsureProfessionnalSocialRegimeRef(),
    ]).subscribe(([category, subCategory, socialRegime]) => {
      this.optionsProfessionCategory = category;
      this.optionsProfessionCategorySub = subCategory;
      this.optionsProfessionSocialRegime = socialRegime;
    });

    this.ownerProfessionDetails.controls.forEach((detailControl, index) => {
      detailControl
        .get('professionalCategory')
        .valueChanges.subscribe(value => {
          const needSubCategory = this.getFilteredSubCategory(value).length > 0;
          if (needSubCategory) {
            detailControl
              .get('professionalCategorySub')
              .setValidators([Validators.required]);
            detailControl
              .get('professionalCategorySub')
              .updateValueAndValidity();
          } else {
            detailControl.get('professionalCategorySub').clearValidators();
            detailControl
              .get('professionalCategorySub')
              .updateValueAndValidity();
          }
        });
    });
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  get ownerProfessionDetails(): UntypedFormArray {
    return this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('ownerProfessionDetails') as UntypedFormArray;
  }

  getFilteredSubCategory(category: string) {
    return [...this.optionsProfessionCategorySub].filter(
      ({ professionCategory }) => professionCategory === category,
    );
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
